import { render } from "./MenuGroupLayoutDesigner.vue?vue&type=template&id=6b6c1464&scoped=true"
import script from "./MenuGroupLayoutDesigner.vue?vue&type=script&lang=js"
export * from "./MenuGroupLayoutDesigner.vue?vue&type=script&lang=js"

import "./MenuGroupLayoutDesigner.vue?vue&type=style&index=0&id=6b6c1464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6c1464"]])

export default __exports__